import React, { useEffect } from "react";
import BigCarImage from "assets/images/big-list-car.png";
import ChatIcon from "assets/icons/chat-icon.png";
import TimeIcon from "assets/icons/time-icon.png";
import MarshalsCarIcon from "assets/svgIcons/CarType/Marshals";
import FBIcon from "assets/svgIcons/CarType/F&B";
import SpecialNeedCarIcon from "assets/svgIcons/CarType/SpecialNeeds";
import MembercarIcon from "assets/svgIcons/CarType/MembercarIcon";
import LockIcon from "assets/svgIcons/LockIcon";
import SignalIcon from "assets/svgIcons/SignalIcon";
import FlagIcon from "assets/svgIcons/FlagIcon";
import ThreeDots from "assets/svgIcons/ThreeDotsIcon";
import UserIcon from "assets/svgIcons/UserIcon";
import SoftwareUpdateIcon from "assets/svgIcons/DownloadIcon";
import TagCarGreenIcon from "assets/svgIcons/TagCarIconGreen";
import BigCar from "assets/svgIcons/BigCar";
import { CarDetailsModalWrapper } from "assets/css/globle";
import NotGuardianCapableIcon from "assets/svgIcons/MapLegendPopup/BatteryStatus/NotGuardianCapable";

import {
    CardWrapper,
    CarSection,
    InfoSection,
    DistanceCover,
    Text,
} from "pages/Fleet/Cars/ListView/CarInfoCard/CarInfoCardStyled";
import {
    FLEET_GLOBAL_STATES,
    MAP_GLOBAL_STATES,
    UPDATED_CAR_DATA_STATE,
} from "globalStore/globalStore";
import { CAR_NUMBER_MESSAGE } from "globalStore/globalStore";
import { MESSAGE_FLEET_GLOBAL_STATES, LIST_BY_GLOBAL_STATES } from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import moment from "moment";
import { CarDetails } from "commonComponents/CarDetails";
import { useSelector } from "react-redux";
import { Modal, Tooltip } from "@mui/material";
import CarNotCommunicatingImage from "assets/svgIcons/CarType/NotCommunication";
import ExclamationMarkIconWithBorder from "assets/svgIcons/ExclamationMarkWithRedBg";
import { isActionZoneAlert } from "_helperFunctions/isActionZoneAlert";
import { isCarInUse } from "_helperFunctions/isCarInUse";
import { isStale } from "_helperFunctions/isStale";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import _ from "lodash";
import { mapHelpers } from "../../../../Pins/utils/mapHelpers";
import { useTranslation } from "react-i18next";
import DistanceHiddenIcon from "assets/svgIcons/MapLegendPopup/BatteryStatus/DistanceHiddenIcon";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import { isUserBasic, isUserReadOnly, distanceUnits, holeLocation, guardianMode, carType, isUserAdmin, isUserSupport, userPrivileges, fleetViewMode, getFeatureSetOption, getFeaturesList, chargeControlMode } from "constant";
import UnLockIcon from "assets/svgIcons/UnlockIcon";
import { useCarSettingsData } from "_helperFunctions/carSettings";
import { ReactComponent as CarIconLegendIcon } from "assets/svgIcons/MapLegendPopup/Status/Outofservice.svg";
import { RenderBatteryColumn } from "./renderBatteryIcon";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { makeStyles } from '@mui/styles';
import { Box, Stack } from "@mui/material";
import { compareCarsByLocation, compareBatteries, comparePace } from "_helperFunctions/carSorting";

const CarInfoCard = React.memo(({ cardata, siteSettingsData, actionZone, rows }) => {
    const { t } = useTranslation();

    const { updatedCarData } = useHookstate(UPDATED_CAR_DATA_STATE);

    const { isReleased } = useCarSettingsData();

    const {
        toggleAppInfo,
        toggleSimInfo,
        toggleFleetCarList,
        toggleSelectedCars,
        toggleUnselectedCars,
        selectedCarList,
        selectedCarList2,
        selectFleetCarsData,
        selectedGpsCarList,
        setMsgToSingleCar,
        storeFleetTagCarData,
        selectedSpeedCarList,
        selectedDistanceUnits,
        selectedDistancesEnabledCar,
        selectMaxHolesCarList,
        selectCarTypeCarList,
        playerNameData1,
        playerNameData2
    } = useHookstate(FLEET_GLOBAL_STATES);

    const { showTaggedCarArray, taggedCarsSaverGlobalState } = useHookstate(MAP_GLOBAL_STATES);

    const {
        setCarNumber,
        carsForMessagesGetter,
        msgBtnState,
        carsGpsSelectorData,
        carsForMessagesGetter2,
        carsGpsSelectorData2,
    } = useHookstate(CAR_NUMBER_MESSAGE);

    const {
        sortBy,
        sortButton
    } = useHookstate(LIST_BY_GLOBAL_STATES);

    const { isLoading } = useHookstate(MESSAGE_FLEET_GLOBAL_STATES);
    const { getCarPathActionZone, getUserRole, getChargeHistoryAction, getPrivilegeAction } = useSelector((state) => state.commonReducers) || [];
    const [openCarDetail, setOpenCarDetail] = React.useState(false);
    const [sortModel, setSortModel] = React.useState([{ field: sortBy.get(), sort: sortButton.get() ? 'desc' : 'asc' }]);
    const [car, setCar] = React.useState(cardata);
    const privilege = "VehicleStatus";

    useEffect(() => {
        setCar(cardata);
    }, [cardata]);

    const newDistance = car?.Car?.DistanceUnits;

    useEffect(() => {
        return () => {
            selectedGpsCarList.set([]);
            selectedSpeedCarList.set([]);
            selectedDistanceUnits.set([]);
            selectMaxHolesCarList.set([]);
            selectCarTypeCarList.set([]);
        };
    }, [newDistance]);

    useEffect(() => {
        setSortModel([{ field: sortBy.get(), sort: sortButton.get() ? 'desc' : 'asc' }]);
    }, [sortBy.get(), sortButton.get()]);

    useEffect(() => {
        setCarNumber.set(0);
        setMsgToSingleCar.set(null);
    }, [toggleFleetCarList.get()]);

    const handleClose = () => {
        setOpenCarDetail(false);
        setMsgToSingleCar.set(null);
        playerNameData1.set("");
        playerNameData2.set("");
    }

    let LOCATION_BETWEEN_HOLES = 1;
    let LOCATION_TEE = 2;
    let LOCATION_FAIRWAY = 3;
    let LOCATION_GREEN = 4;

    let LOCATION_BETWEEN_HOLES_STR = "BetweenHoles";
    let LOCATION_TEE_STR = "Tee";
    let LOCATION_FAIRWAY_STR = "Fairway";
    let LOCATION_GREEN_STR = "Green";

    const player1 = car?.Car?.PlayerName1;
    const player2 = car?.Car?.PlayerName2;
    const paceWarning = car?.Car?.PaceStatus === 2;
    const paceCritical = car?.Car?.PaceStatus === 3;

    const showCarDetails = (carInfoData) => {
        setMsgToSingleCar.set(carInfoData.Car.CarNumber);
        if (carInfoData !== "") {
            storeFleetTagCarData.set(carInfoData.Car);
        }
        setOpenCarDetail(true);
    }

    function paceString(car) {
        let result = "";
        if (car) {
            if (car?.Car?.Pace > 0)
                result = car?.Car?.Pace.toString() + " min ahead ";
            else if (car?.Car?.Pace < 0)
                result = (-car?.Car?.Pace).toString() + " min behind ";
            else result = "on pace ";
            if (car?.Car?.HolesPlayed > 0)
                result =
                    result +
                    "through " +
                    car?.Car?.HolesPlayed.toString() +
                    " hole" +
                    (car?.Car?.HolesPlayed > 1 ? "s" : "");
        }
        return result;
    }

    const timeZoneOffset = siteSettingsData && siteSettingsData?.TimeZoneOffset;

    function renderCarName() {
        if (car?.Car?.CarType === 0) {
            return <span className="card-view">outsidePerimeterCars</span>;
        } else if (car?.Car?.CarType === 1) {
            return <span className="card-view">Fleet Car</span>;
        } else if (car?.Car?.CarType === 2) {
            return <span className="card-view">{t("Marshal_cars")}</span>;
        } else if (car?.Car?.CarType === 3) {
            return <span className="card-view">{t("Special_needs_cars")}</span>;
        } else if (car?.Car?.CarType === 4) {
            return <span className="card-view">{t("Beverage_cars")}</span>;
        }
        else if (car?.Car?.CarType === 5) {
            return <span className="card-view">{t("Out_of_service")}</span>;
        }
        else if (car?.Car?.CarType === 6) {
            return <span className="card-view">Not In Use Car</span>;
        } else if (car?.Car?.CarType === 7) {
            return <span className="card-view">Not Communicating Car</span>;
        } else {
            return <span className="card-view">Not Available Car Name</span>;
        }
    }

    function renderCarIcon(car) {
        if (car?.Car?.CarType === 0) {
        } else if (car?.Car?.CarType === carType.normal) {
        } else if (car?.Car?.CarType === carType.marshal) {
            return <MarshalsCarIcon width={18} height={19} />;
        } else if (car?.Car?.CarType === carType.handicap) {
            return <SpecialNeedCarIcon width={15} height={23} />;
        } else if (car?.Car?.CarType === carType.bevcart) {
            return <FBIcon width={18} height={19} />;
        } else if (car?.Car?.CarType === carType.outOfService) {
            return <></>;
        } else if (car?.Car?.CarType === carType.member && car?.Car?.SecondaryCarType === carType.handicap) {
            return <div style={{ display: "flex" }}><MembercarIcon width={20} height={33} bg={"#00A000"} opacity={1}></MembercarIcon><SpecialNeedCarIcon width={15} height={23} bg={"#0026AC"} /></div>;
        } else if (car?.Car?.CarType === carType.member) {
            return <MembercarIcon width={20} height={33} bg={"#00A000"} opacity={1}></MembercarIcon>;
        } else {
            return <span className="card-view">Not Icon</span>;
        }
    }

    const toolTipIcon = (car) => {
        if (car?.Car?.CarType === carType.marshal) {
            return "This car is marked as marshal car";
        } else if (car?.Car?.CarType === carType.handicap) {
            return "This car is marked as special needs";
        } else if (car?.Car?.CarType === carType.bevcart) {
            return "This car is marked as beverage car";
        } else if (car?.Car?.CarType === carType.member && car?.Car?.SecondaryCarType === carType.handicap) {
            return "This car is marked as member/special car";
        } else if (car?.Car?.CarType === carType.member) {
            return "This car is marked as member car";
        } else {
            return "This car is marked as fleet car";
        }
    }

    function renderLocationString() {
        if (car?.Car?.Course === 0) {
            return (
                <>
                    <span style={{ color: "#947550" }}>{locationString(car)}</span>
                </>
            );
        } else if (car?.Car?.Course === 1) {
            return (
                <>
                    <span
                        style={{
                            color:
                                siteSettingsData &&
                                mapHelpers.CourseBGColor(siteSettingsData, car?.Car?.Course),
                        }}
                    >
                        {locationString(car)}
                    </span>
                </>
            );
        } else if (car?.Car?.Course === 2) {
            return (
                <>
                    <span
                        style={{
                            color:
                                siteSettingsData &&
                                mapHelpers.CourseBGColor(siteSettingsData, car?.Car?.Course),
                        }}
                    >
                        {locationString(car)}
                    </span>
                </>
            );
        } else if (car?.Car?.Course === 3) {
            return (
                <>
                    <span
                        style={{
                            color:
                                siteSettingsData &&
                                mapHelpers.CourseBGColor(siteSettingsData, car?.Car?.Course),
                        }}
                    >
                        {locationString(car)}
                    </span>
                </>
            );
        } else {
            return <span className="number-dig">not available</span>;
        }
    }

    function renderHoleNumber(car) {
        if (isCarInUse(car?.Car) && car?.Car?.Hole != 0 && (!getFeatureSetOption(
            siteSettingsData?.Features,
            getFeaturesList().real_time_tracking
        ) || isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role))) {
            if (car?.Car?.Course === 0) {
                return (
                    <div className="flag-wrapper" style={{ backgroundColor: "#947550" }}>
                        <FlagIcon color="#000" />
                        <span className="number-dig" style={{ color: "#000" }}>
                            {car?.Car?.Hole}
                        </span>
                    </div>
                );
            } else if (car?.Car?.Course === 1) {
                return (
                    <div
                        style={{
                            backgroundColor: mapHelpers.CourseBGColor(
                                siteSettingsData,
                                car?.Car?.Course
                            ),
                        }}
                        className="flag-wrapper"
                    >
                        <FlagIcon
                            color={
                                siteSettingsData &&
                                    mapHelpers.lightOrDark(
                                        mapHelpers.CourseBGColor(siteSettingsData, car?.Car?.Course)
                                    ) === "light"
                                    ? "#000000"
                                    : "#ffffff"
                            }
                        />
                        <span
                            className="number-dig"
                            style={{
                                color:
                                    siteSettingsData &&
                                        mapHelpers.lightOrDark(
                                            mapHelpers.CourseBGColor(siteSettingsData, car?.Car?.Course)
                                        ) === "light"
                                        ? "#000000"
                                        : "#ffffff",
                            }}
                        >
                            {car?.Car?.Hole}
                        </span>
                    </div>
                );
            } else if (car?.Car?.Course === 2) {
                return (
                    <div
                        className="flag-wrapper"
                        style={{
                            backgroundColor: mapHelpers.CourseBGColor(
                                siteSettingsData,
                                car?.Car?.Course
                            ),
                        }}
                    >
                        <FlagIcon
                            color={
                                siteSettingsData &&
                                    mapHelpers.lightOrDark(
                                        mapHelpers.CourseBGColor(siteSettingsData, car?.Car?.Course)
                                    ) === "light"
                                    ? "#000000"
                                    : "#ffffff"
                            }
                        />
                        <span
                            className="number-dig"
                            style={{
                                color:
                                    siteSettingsData &&
                                        mapHelpers.lightOrDark(
                                            mapHelpers.CourseBGColor(siteSettingsData, car?.Car?.Course)
                                        ) === "light"
                                        ? "#000000"
                                        : "#ffffff",
                            }}
                        >
                            {car?.Car?.Hole}
                        </span>
                    </div>
                );
            } else if (car?.Car?.Course === 3) {
                return (
                    <div
                        className="flag-wrapper"
                        style={{
                            backgroundColor: mapHelpers.CourseBGColor(
                                siteSettingsData,
                                car?.Car?.Course
                            ),
                        }}
                    >
                        <FlagIcon
                            color={
                                siteSettingsData &&
                                    mapHelpers.lightOrDark(
                                        mapHelpers.CourseBGColor(siteSettingsData, car?.Car?.Course)
                                    ) === "light"
                                    ? "#000000"
                                    : "#ffffff"
                            }
                        />
                        <span
                            className="number-dig"
                            style={{
                                color:
                                    siteSettingsData &&
                                        mapHelpers.lightOrDark(
                                            mapHelpers.CourseBGColor(siteSettingsData, car?.Car?.Course)
                                        ) === "light"
                                        ? "#000000"
                                        : "#ffffff",
                            }}
                        >
                            {car?.Car?.Hole}
                        </span>
                    </div>
                );
            } else {
                return <span className="number-dig">not available</span>;
            }
        }
    }

    const carGuardianCapable = function (car) {
        return car?.GuardianCapable !== false;
    }
    
    const carNotGuardianCapable = function (car) {
        return ((siteSettingsData.GuardianCapable && car.GuardianCapable === false) || (siteSettingsData.GuardianCapable === false && car.GuardianCapable === null));
    };

    const isSiteUsingYards = () =>
        siteSettingsData.DistanceUnits === distanceUnits.Yards;

    const findStagingOrLockMode = function () {
        return (
            siteSettingsData.GuardianCapable &&
            siteSettingsData.GuardianMode !== guardianMode.normal
        );
    }

    var convertMileToKM = function (mile) {
        return mile * 1.609344000001;
    }

    function renderLockMode(car) {
        if (carGuardianCapable(car) && !car?.AllowedToMove) {
            return (
                <Tooltip title={t("This_car_is_locked")}>
                    <div>
                        <LockIcon />
                    </div>
                </Tooltip>
            );
        }

        if (isReleased(car)) {
            return (
                <Tooltip title={t("This_car_is_released")}>
                    <div>
                        <UnLockIcon />
                    </div>
                </Tooltip>
            );
        }

        if (car.MaxSpeed > 0 &&
            carGuardianCapable(car) &&
            car.AllowedToMove &&
            (car.HasMoved || !findStagingOrLockMode())
        ) {
            return (
                <Tooltip title={t("Speed_limit_set_on_this_car")}>
                    <div style={{ fontSize: "16px", border: "1px solid #000", padding: 3 }}>
                        {isSiteUsingYards()
                            ? car?.MaxSpeed
                            : Math.round(convertMileToKM(car?.MaxSpeed))}
                    </div>
                </Tooltip>
            );
        }
    }

    function checkLastDate() {
        let updated = moment
            .utc(car?.Car?.LastLocationUpdateInUtc)
            .utcOffset(-timeZoneOffset);
        let now = moment();
        if (updated.isAfter(now)) updated = now;
        return updated.format("ddd DD/MMM/YY hh:mm:ss a");
    }

    function renderHoleNumber1() {
        if (car?.Car?.Course === 0) {
            return 0;
        } else if (car?.Car?.Course === 1) {
            return (
                <>
                    <span>{locationString(car)}</span>
                </>
            );
        } else if (car?.Car?.Course === 2) {
            return (
                <>
                    <span>{locationString(car)}</span>
                </>
            );
        } else if (car?.Car?.Course === 3) {
            return (
                <>
                    <span>{locationString(car)}</span>
                </>
            );
        } else {
            return <span className="number-dig">not available</span>;
        }
    }

    function lastUpdate() {
        var updated = moment
            .utc(car?.Car?.LastLocationUpdateInUtc)
            .utcOffset(-timeZoneOffset); // convert to local time zone at course
        var now = moment(); // Note: moment apparently knows how to compare them even though zone applied to "updated"
        if (updated.isAfter(now)) updated = now;
        return updated.from(now);
    }

    function pendingUpdate(abbrev) {
        let code = abbrev.substr(0, 2);
        let flag = abbrev.length > 2 ? abbrev.substr(2, 1) : "";
        let result = "";

        switch (code) {
            case "AD":
                result = "Action zone disabled list";
                break;
            case "AE":
                result = "Action zones";
                break;
            case "AF":
                result = "Auto flyovers";
                break;
            case "AM":
                result = "Car movement";
                break;
            case "AO":
                result = "Android OS";
                break;
            case "AP":
                result = "APN config";
                break;
            case "AZ":
                result = "Action zones";
                break;
            case "BP":
                result = "Blindshots";
                break;
            case "CD":
                result = "Car Distances Override";
                break;
            case "CT":
                result = "Car type";
                break;
            case "DE":
                result = "Distances";
                break;
            case "DU":
                result = "Dist units";
                break;
            case "FB":
                result = "Food & bev";
                break;
            case "FD":
                result = "F&B items";
                break;
            case "FM":
                result = "F&B menu";
                break;
            case "GG":
                result = "Golf genius";
                break;
            case "GO":
                result = "GPS odometer base";
                break;
            case "MA":
                result = "Max holes alert";
                break;
            case "MC":
                result = "Max holes allowed-car";
                break;
            case "MD":
                result = "Max holes distances";
                break;
            case "MF":
                result = "Files (ads, etc)";
                break;
            case "MH":
                result = "Max holes allowed-fleet";
                break;
            case "MX":
                result = "Max speed";
                break;
            case "OS":
                result = "OS ver";
                break;
            case "FS":
                result = "FS ver";
                break;
            case "P1":
                result = "Player 1 / driver";
                break; // TBD: add separate abbrev for Resort name/dept
            case "P2":
                result = "Player 2 / dept";
                break;
            case "PE":
                result = "Pace";
                break;
            case "PS":
                result = "Pace settings";
                break;
            case "PM":
                result = "Pwr mgmt";
                break;
            case "PP":
                result = "Pins";
                break;
            case "SC":
                result = "Scorecards";
                break;
            case "SE":
                result = "Shark experience";
                break;
            case "SH":
                result = "Show names on welcome screen";
                break;
            case "SM":
                result = "Guardian mode";
                break;
            case "GC":
                result = "Guardian capable";
                break;
            case "SP":
                result = "Score printing";
                break;
            case "SS":
                result = "Speaker setting";
                break;
            case "SW":
                result = "SW ver";
                break;
            case "SY":
                result = "SW sys";
                break;
            case "TC":
                result = "Tourn config";
                break;
            case "TO":
                result = "Tournament";
                break;
            case "UI":
                result = "V UI";
                break;
            case "VH":
                result = "Virtual hour meter base";
                break;
            case "VP":
                result = "V App";
                break;
            case "WA":
                result = "Weather alert";
                break;
            case "WT":
                result = "Welcome text";
                break;
            case "SD":
                result = "Site data";
                break;
            case "PO":
                result = "POIs";
                break;
            case "TM":
                result = "Tee markers";
                break;
            case "MP":
                result = "Maps";
                break;
            default:
                result = abbrev;
        }

        if (flag !== "") {
            result += flag === "1" ? " enabled" : " disabled";
        }
        return result;
    }

    function updatesList(car) {
        if (car?.Car?.UpdatesPending) {
            let result = t("This_car_has_pending_updates") + " (";
            let updates = car?.Car?.UpdatesPending.split(",");
            for (let i = 0; i < updates.length; i++) {
                result += pendingUpdate(updates[i]);
                if (i < updates.length - 1) result += ", ";
            }
            result += ")";
            return result;
        }
    }

    function holeLocationString(x) {
        if (x === LOCATION_BETWEEN_HOLES || x === LOCATION_BETWEEN_HOLES_STR)
            return "Between Holes";
        else if (x === LOCATION_TEE || x === LOCATION_TEE_STR) return "Tee";
        else if (x === LOCATION_FAIRWAY || x === LOCATION_FAIRWAY_STR)
            return "Fairway";
        else if (x === LOCATION_GREEN || x === LOCATION_GREEN_STR) return "Green";
        else return "Unknown"; // "Unknown Hole Location";
    }

    function locationString(car) {
        if (
            car !== undefined &&
            car !== null &&
            siteSettingsData &&
            Object.keys(siteSettingsData).length > 0
        ) {
            let result = "";
            if (car?.Car?.Course === 0 || car?.Car?.Hole === 0) result = "-";
            else if (siteSettingsData?.Courses.length === 1)
                // TBD handle null siteSettings
                result = "Hole " + car?.Car?.Hole.toString();
            else {
                let results = siteSettingsData?.Courses.filter((e) => {
                    return e.Number === car?.Car?.Course;
                });

                if (results.length > 0) {
                    result = results[0].Name + " " + car?.Car?.Hole.toString();
                } else {
                    result =
                        "Course " +
                        car?.Car?.Course.toString() +
                        " hole " +
                        car?.Car?.Hole.toString();
                }
            }

            if (car?.Car?.HoleLocation > holeLocation.unknown) {
                result = result + " " + holeLocationString(car?.Car?.HoleLocation);
            }

            return result;
        }
    }

    function actionZoneText(car) {
        var txt = "";
        if (getActionZoneLabel(car?.Car?.ActionZoneId) !== "") {
            txt = getActionZoneLabel(car?.Car?.ActionZoneId);
        } else {
        }
        return txt;
    }

    function getActionZoneLabel(azID) {
        if (actionZone && actionZone.length !== 0) {
            var az = _.find(actionZone, function (dcAZ) {
                return dcAZ.Id === azID;
            });
            if (az) {
                return az.Label ? az.Label : "";
            }
        }
        return "";
    }

    function isOutOfService(car) {
        return car?.Car?.CarType === carType.outOfService;
    }

    const handleCarClick = (
        carData,
        carNumber,
        carGpsiCarId,
        MaxSpeed,
        DistanceUnits,
        MaxHolesAllowedCar,
        CarType,
        DistancesEnabledCar
    ) => {
        const carDataExist = selectFleetCarsData
            .get()
            .find((item) => item?.CarNumber === carNumber);

        if (carDataExist) {
            selectFleetCarsData.set((tasks) =>
                tasks.filter((item) => item?.CarNumber !== carNumber)
            );
        } else {
            selectFleetCarsData.set((item) => [...item, carData]);
        }

        const carNumberExist = selectedCarList
            .get()
            .find((item) => item === carNumber);
        if (carNumberExist) {
            selectedCarList.set((tasks) =>
                tasks.filter((item) => item !== carNumber)
            );
        } else {
            selectedCarList.set((item) => [...item, carNumber]);
        }

        const carNumberExist2 = selectedCarList2
            .get()
            .find((item) => item === carNumber);
        if (carNumberExist2) {
            selectedCarList2.set((tasks) =>
                tasks.filter((item) => item !== carNumber)
            );
        } else {
            selectedCarList2.set((item) => [...item, carNumber]);
        }

        const maxHolesExist = selectMaxHolesCarList
            .get()
            .find((item) => item == MaxHolesAllowedCar);
        if (maxHolesExist) {
            selectMaxHolesCarList.set((tasks) =>
                tasks.filter((item) => item == MaxHolesAllowedCar)
            );
        } else {
            selectMaxHolesCarList.set((item) => [...item, MaxHolesAllowedCar]);
        }
        const CarTypeExist = selectCarTypeCarList
            .get()
            .find((item) => item === CarType);
        if (CarTypeExist) {
            selectCarTypeCarList.set((tasks) =>
                tasks.filter((item) => item == CarType)
            );
        } else {
            selectCarTypeCarList.set((item) => [...item, CarType]);
        }
        const carGpsiCarIdExist = selectedGpsCarList
            .get()
            .find((item) => item === carGpsiCarId);
        if (carGpsiCarIdExist) {
            selectedGpsCarList.set((tasks) =>
                tasks.filter((item) => item !== carGpsiCarId)
            );
        } else {
            selectedGpsCarList.set((item) => [...item, carGpsiCarId]);
        }
        const carSpeedExist = selectedSpeedCarList
            .get()
            .find((item) => item == MaxSpeed);
        if (carSpeedExist) {
            selectedSpeedCarList.set((tasks) =>
                tasks.filter((item) => item == MaxSpeed)
            );
        } else {
            selectedSpeedCarList.set((item) => [...item, MaxSpeed]);
        }
        const carDistanceExist = selectedDistanceUnits
            .get()
            .find((item) => item == DistanceUnits);
        if (carDistanceExist) {
            selectedDistanceUnits.set((tasks) =>
                tasks.filter((item) => item == DistanceUnits)
            );
        } else {
            selectedDistanceUnits.set((item) => [...item, DistanceUnits]);
        }

        const distancesEnabledCarExist = selectedDistancesEnabledCar
            .get()
            .find((item) => item == DistancesEnabledCar);
        if (distancesEnabledCarExist) {
            selectedDistancesEnabledCar.set((tasks) =>
                tasks.filter((item) => item == DistancesEnabledCar)
            );
        } else {
            selectedDistancesEnabledCar.set([DistancesEnabledCar]);
        }

        const exist2 = showTaggedCarArray.get().find((item) => item === carNumber);
        if (exist2) {
            showTaggedCarArray.set((tasks) =>
                tasks.filter((task) => task !== carNumber)
            );
        } else {
            showTaggedCarArray.set((tasks) => [...tasks, carNumber]);
        }

        const carMessage = carsForMessagesGetter2
            .get()
            .find((item) => item === carNumber);
        if (carMessage) {
            carsForMessagesGetter2.set((tasks) =>
                tasks.filter((task) => task !== carNumber)
            );
        } else {
            carsForMessagesGetter2.set((tasks) => [...tasks, carNumber]);
        }

        const carGpsiCarIdNumber = carsGpsSelectorData2
            .get()
            .find((item) => item === carGpsiCarId);
        if (carGpsiCarIdNumber) {
            carsGpsSelectorData2.set((tasks) =>
                tasks.filter((task) => task !== carGpsiCarId)
            );
        } else {
            carsGpsSelectorData2.set((tasks) => [...tasks, carGpsiCarId]);
        }
    }

    function backColor(car) {
        const carsData =
            updatedCarData.get() && JSON.parse(updatedCarData.get()).length !== 0
                ? JSON.parse(updatedCarData.get())
                : [];

        if (
            toggleSelectedCars.get() &&
            selectedCarList.get().length === carsData.length
        ) {
            return {
                background: "var(--car-selection-bg) !important",
                borderLeft: "5px solid var(--theme-background) !important",
            };
        } else if (selectedCarList.get().includes(car?.Car?.CarNumber)) {
            return {
                background: "var(--car-selection-bg) !important",
                borderLeft: "5px solid var(--theme-background) !important",
            };
        } else if (
            (isActionZoneAlert(getCarPathActionZone, car?.Car?.ActionZoneId) ||
                car?.Car?.MaxHolesExceeded ||
                car?.Car?.hasChargeAlert) &&
            !isStale(car?.Car)
        ) {
            return { background: toggleFleetCarList?.get() === 2 ? "var(--car-actionzone-bg) !important" : "var(--car-actionzone-bg)", borderLeft: "5px solid transparent" };
        } else if (car?.Car?.CarType === carType?.member) {
            return { background: toggleFleetCarList?.get() === 2 ? "#00A000 !important" : "#00A000", borderLeft: "5px solid transparent" };
        }
        else if (
            (car?.Car?.PaceStatus === 3 &&
                !toggleSelectedCars.get() &&
                !selectedCarList.get().includes(car?.Car?.CarNumber)) ||
            (car?.Car?.PaceStatus === 3 && toggleUnselectedCars.get())
        ) {
            return {
                background: selectedCarList.get().includes(car?.Car?.CarNumber)
                    ? "var(--car-selection-bg) !important"
                    : toggleFleetCarList?.get() === 2 ? "#FFF3F2 !important" : "#FFF3F2",
                borderLeft: selectedCarList.get().includes(car?.Car?.CarNumber)
                    ? "5px solid var(--theme-background)  !important"
                    : toggleFleetCarList?.get() === 2 ? "5px solid #E2261A !important" : "5px solid #E2261A",
            };
        } else if (
            (car?.Car?.PaceStatus === 2 &&
                !toggleSelectedCars.get() &&
                !selectedCarList.get().includes(car?.Car?.CarNumber)) ||
            (car?.Car?.PaceStatus === 2 && toggleUnselectedCars.get())
        ) {
            return {
                background: selectedCarList.get().includes(car?.Car?.CarNumber)
                    ? "var(--car-selection-bg) !important"
                    : toggleFleetCarList?.get() === 2 ? "#fffff2 !important" : "#fffff2",
                borderLeft: selectedCarList.get().includes(car?.Car?.CarNumber)
                    ? "5px solid var(--theme-background) !important"
                    : toggleFleetCarList?.get() === 2 ? "5px solid #cee21a !important" : "5px solid #cee21a",
            };
        }
        else if (
            (isActionZoneAlert(getCarPathActionZone, car?.Car?.ActionZoneId) ||
                car?.Car?.MaxHolesExceeded ||
                car?.Car?.hasChargeAlert) &&
            isStale(car?.Car)
        ) {
            return { background: toggleFleetCarList?.get() === 2 ? "#ffabab !important" : "#ffabab", borderLeft: "5px solid transparent" };
        } else if (isOutOfService()) {
            return {
                background: "gray !important",
                borderLeft: "5px solid transparent !important",
            };
        } else {
            return {
                background: toggleFleetCarList?.get() === 2 ? "white !importnant" : "var(--car-unSelected-bg) !important",
                borderLeft: "5px solid var(--border-color) !important",
            };
        }
    }

    let tagFind = taggedCarsSaverGlobalState
        .get()
        .find((item) => item === car?.Car.CarNumber);

    let tagFinder = JSON.parse(localStorage.getItem("taggedCarsData"));
    let tagFind2 = tagFinder?.tagCarsDataFilters.find(
        (item) => item === car?.Car.CarNumber
    );

    const distanceCover = (dis, showOrHide) => {
        return (
            <DistanceCover>
                <Text className={showOrHide == null ? "only-text" : ""}>{dis}</Text>
                {showOrHide !== null && showOrHide === "hide" && <DistanceHiddenIcon />}
                {showOrHide !== null && showOrHide === "show" && (
                    <CircleOutlinedIcon style={{ color: "green" }} />
                )}
            </DistanceCover>
        );
    }

    const showDistanceUnits = (car) => {
        if (car?.Car?.DistanceUnits === siteSettingsData.DistanceUnits) {
            // car unit equal to site setting unit
            if (siteSettingsData.ShowDistances) {
                // Check hot hide distance enable
                if (car?.Car?.DistancesEnabledCar === 0) {
                    if (car?.Car?.DistanceUnits === 2)
                        return distanceCover("m", "hide");
                    if (car?.Car?.DistanceUnits === 1)
                        return distanceCover("yds", "hide");
                }
            }
            if (!siteSettingsData.ShowDistances) {
                if (car?.Car?.DistancesEnabledCar === 1) {
                    if (car?.Car?.DistanceUnits === 2)
                        return distanceCover("m", "show");
                    if (car?.Car?.DistanceUnits === 1)
                        return distanceCover("yds", "show");
                }
            }
        }

        if (car?.Car?.DistanceUnits !== siteSettingsData.DistanceUnits) {
            // car unit not equal to site setting unit
            if (siteSettingsData.ShowDistances) {
                // Check hot hide distance enable
                if (car?.Car?.DistancesEnabledCar === 0) {
                    // checking the car for hide distance
                    if (car?.Car?.DistanceUnits === 2)
                        return distanceCover("m", "hide");
                    if (car?.Car?.DistanceUnits === 1)
                        return distanceCover("yds", "hide");
                }
            }
            if (!siteSettingsData.ShowDistances) {
                if (car?.Car?.DistancesEnabledCar === 1) {
                    // checking the car for show distance
                    if (car?.Car?.DistanceUnits === 2)
                        return distanceCover("m", "show");
                    if (car?.Car?.DistanceUnits === 1)
                        return distanceCover("yds", "show");
                }
            }
            if (car?.Car?.DistanceUnits === 2)
                return distanceCover("m", null);
            if (car?.Car?.DistanceUnits === 1)
                return distanceCover("yds", null);
        }
    }

    const maxHolesDataDisplay = (max) => {
        if (
            (max && siteSettingsData.MaxHolesAllowedFleet &&
                siteSettingsData.MaxHolesAllowedFleet !== max) ||
            (max > 0 && siteSettingsData.MaxHolesAllowedFleet <= 0) ||
            (max === -1 && siteSettingsData.MaxHolesAllowedFleet > 0)
        ) {
            if (max === -1)
                return (
                    <span style={{ backgroundColor: "green", color: "white" }}>
                        &nbsp;U&nbsp;
                    </span>
                );
            else
                return (
                    <span style={{ backgroundColor: "red", color: "white" }}>
                        &nbsp;{max}&nbsp;
                    </span>
                );
        }
        // return max
    }

    const showTooltipTitle = (car) => {
        if (car?.Car?.DistanceUnits === 2) {
            return "Distances shown in meters";
        } else if (car?.Car?.DistanceUnits === 1) {
            return "Distances shown in yards";
        }
    }

    const isWifi = (car) => {
        let nowUtc = moment.utc();
        let lastWiFiUtc = moment.utc(car?.LastWiFiInUtc);
        lastWiFiUtc.add(6, "minutes");
        return nowUtc.isBefore(lastWiFiUtc);
    }

    const handleCellClick = (params) => {
        setCar(params?.row?.action);
        if (params.field === "car") {
            let car = params?.row?.action;
            handleCarClick(
                car?.Car,
                car?.Car?.CarNumber,
                car?.Car?.GpsiCarId,
                car?.Car?.MaxSpeed,
                car?.Car?.DistanceUnits,
                car?.Car?.MaxHolesAllowedCar,
                car?.Car?.CarType
            );
        }
        else {
            setOpenCarDetail(true);
        }
    }
    const columnColor = () => {
        let style = { backgroundColor: "#c3e9e9 !important" };
        const carStyle = makeStyles(() => ({
            carnumber: style
        }));
        const carclass = carStyle();
        return carclass.carnumber;
    }
    const columns = [
        {
            field: "car",
            headerName: t("car"),
            flex: 1,
            headerAlign: "center",
            justifyContent: "center",
            minWidth: 80,
            pinned: "left",
            cellClassName: (params) => {
                let style = backColor(params?.row?.action);
                style.cursor = "pointer";
                const carStyle = makeStyles(() => ({
                    carnumber: style,
                }));
                const carclass = carStyle();
                return carclass.carnumber;
            },
        },
        {
            field: "gpsiID",
            headerName: t("GPSI_ID"),
            flex: 1,
            headerAlign: "center",
            justifyContent: "center",
            minWidth: 100,
            pinned: "left",
            cellClassName: () => {
                return columnColor();
            },
        },
        {
            field: "battery",
            headerName: t("Battery"),
            flex: 1,
            headerAlign: "center",
            justifyContent: "center",
            renderCell: (params) => {
                const car = params?.value;
                return (
                    <>
                        <RenderBatteryColumn
                            car={car}
                            canCommunicate={params?.row?.action?.CanCarCommunicate}
                            userRole={getUserRole && getUserRole?.Role}
                            getPrivilegeAction={getPrivilegeAction}
                            privilege={privilege}
                            getChargeHistoryAction={getChargeHistoryAction}
                        />
                        {carNotGuardianCapable(car) && <span title="This car is NOT Guardian capable" style={{ fontSize: '0.7em', textAlign: 'right', marginLeft: 4, color: '#cc0404' }}>
                            <NotGuardianCapableIcon width={17} height={17} />
                        </span>}
                    </>
                );
            },
            sortComparator: (v1, v2) => {
                return compareBatteries(v1, v2);
            },
            minWidth: 100,
        },
        {
            field: "location",
            headerName: t("Location"),
            flex: 1,
            headerAlign: "center",
            justifyContent: "center",
            renderCell: (params) => {
                return renderHoleNumber(params?.value) !== undefined ? (
                    <Tooltip title={locationString(params?.value)}>
                        <span>
                            <div style={{ display: "inline-flex", alignItems: "center" }}>
                                {renderHoleNumber(params?.value)}
                            </div>
                        </span>
                    </Tooltip>
                ) : (
                    <span>{actionZoneText(params?.value)}</span>
                );
            },
            sortComparator: (v1, v2) => {
                return compareCarsByLocation(v1, v2, getCarPathActionZone);
            },
            minWidth: 110,
        },
        {
            field: "pace",
            headerName: t("Pace"),
            flex: 1,
            headerAlign: "center",
            justifyContent: "center",
            renderCell: (params) => {
                return (
                    <div className="pace-section">
                        <span className="pace">
                            <Tooltip title={paceString(params?.value)}>
                                <div className="flex">
                                    {params?.value?.Car.PaceStatus === 2 && (
                                        <span
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "3px",
                                                fontSize: "16px",
                                            }}
                                        >
                                            <AccessTimeOutlinedIcon style={{ color: "orange" }} />{" "}
                                            {Math.abs(params?.value?.Car.Pace)}
                                        </span>
                                    )}
                                    {params?.value?.Car.PaceStatus === 3 && (
                                        <span
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "3px",
                                                fontSize: "16px",
                                            }}
                                        >
                                            <AccessTimeOutlinedIcon style={{ color: "red" }} />{" "}
                                            {Math.abs(params?.value?.Car?.Pace)}
                                        </span>
                                    )}
                                </div>
                            </Tooltip>
                        </span>
                    </div>
                );
            },
            sortComparator: (v1, v2) => {
                return comparePace(v1, v2);
            },
            minWidth: 90,
        },
        {
            field: "player1",
            headerName: t("player1"),
            flex: 1,
            headerAlign: "center",
            justifyContent: "center",
            minWidth: 100,
        },
        {
            field: "player2",
            headerName: t("player2"),
            flex: 1,
            headerAlign: "center",
            justifyContent: "center",
            minWidth: 100,
        },
        {
            field: "lastlocation",
            headerName: t("Last_location"),
            flex: 1,
            headerAlign: "center",
            justifyContent: "center",
            minWidth: 150,
            renderCell: (params) => {
                let car = params?.row?.icons;
                var updated = moment
                    .utc(params?.value)
                    .utcOffset(-siteSettingsData.TimeZoneOffset); // convert to local time zone at course
                var now = moment(); // Note: moment apparently knows how to compare them even though zone applied to "updated"
                if (updated.isAfter(now)) updated = now;
                return (
                    <div
                        style={{
                            gap: "10px",
                            width: "99px",
                            alignItems: "center",
                            display: "flex",
                        }}
                    >
                        {" "}
                        {isStale(car?.Car) ? (
                            <Tooltip title={t("This_car_is_not_communicating_with_server")}>
                                <div>
                                    <CarNotCommunicatingImage color="red" />
                                </div>
                            </Tooltip>
                        ) : (
                            <span style={{ width: "24px" }}></span>
                        )}
                        <span> {updated.from(now)}</span>
                    </div>
                );
            },
        },
        {
            field: "connectedSSID",
            headerName: t("Wifi_Network"),
            flex: 1,
            headerAlign: "center",
            justifyContent: "center",
            minWidth: 100,
        },
        {
            field: "lastRT",
            headerName: t("Last_RT"),
            flex: 1,
            headerAlign: "center",
            justifyContent: "center",
            minWidth: 150,
            renderCell: (params) => {
                var updated = moment
                    .utc(params?.value)
                    .utcOffset(-siteSettingsData.TimeZoneOffset); // convert to local time zone at course
                if (updated.isAfter("1900-01-01")) {
                    var now = moment(); // Note: moment apparently knows how to compare them even though zone applied to "updated"
                    if (updated.isAfter(now)) updated = now;

                    if (now.diff(updated, "days", true) > 30) {
                        return updated.from(now);
                    } else {
                        var duration = moment.duration(now.diff(updated));
                        var days = duration.get("d");
                        var hours = duration.get("h");
                        var mins = duration.get("m");
                        var secs = duration.get("s");
                        var timeDisplay = moment({
                            hours: hours,
                            minutes: mins,
                            seconds: secs,
                        });
                        var dayPart =
                            days === 1 ? "1 day " : days > 1 ? days + " days " : "";
                        return dayPart + timeDisplay.format("HH:mm:ss") + " ago";
                    }
                }
                return "";
            },
            cellClassName: () => {
                return columnColor();
            },
        },
        {
            field: "lastWiFi",
            headerName: t("Last_WIFI"),
            flex: 1,
            headerAlign: "center",
            justifyContent: "center",
            minWidth: 150,
            renderCell: (params) => {
                var updated = moment
                    .utc(params?.value)
                    .utcOffset(-siteSettingsData.TimeZoneOffset); // convert to local time zone at course
                if (updated.isAfter("1900-01-01")) {
                    var now = moment(); // Note: moment apparently knows how to compare them even though zone applied to "updated"
                    if (updated.isAfter(now)) updated = now;

                    if (now.diff(updated, "days", true) > 30) {
                        return updated.from(now);
                    } else {
                        var duration = moment.duration(now.diff(updated));
                        var days = duration.get("d");
                        var hours = duration.get("h");
                        var mins = duration.get("m");
                        var secs = duration.get("s");
                        var timeDisplay = moment({
                            hours: hours,
                            minutes: mins,
                            seconds: secs,
                        });
                        var dayPart =
                            days === 1 ? "1 day " : days > 1 ? days + " days " : "";
                        return dayPart + timeDisplay.format("HH:mm:ss") + " ago";
                    }
                }
                return "";
            },
            cellClassName: () => {
                return columnColor();
            },
        },
        {
            field: "simCard",
            headerName: t("SIM_Card"),
            flex: 1,
            headerAlign: "center",
            justifyContent: "center",
            minWidth: 170,
            cellClassName: () => {
                return columnColor();
            },
        },
        {
            field: "imei",
            headerName: t("IMEI"),
            flex: 1,
            headerAlign: "center",
            justifyContent: "center",
            minWidth: 150,
            cellClassName: () => {
                return columnColor();
            },
        },
        {
            field: "pmid",
            headerName: t("PMID"),
            flex: 1,
            headerAlign: "center",
            justifyContent: "center",
            minWidth: 90,
            cellClassName: () => {
                return columnColor();
            },
        },
        {
            field: "vapp",
            headerName: t("V*App"),
            flex: 1,
            headerAlign: "center",
            justifyContent: "center",
            minWidth: 100,
            cellClassName: () => {
                return columnColor();
            },
        },
        {
            field: "vui",
            headerName: t("V*UI"),
            flex: 1,
            headerAlign: "center",
            justifyContent: "center",
            minWidth: 80,
            cellClassName: () => {
                return columnColor();
            },
        },
        {
            field: "vlauncher",
            headerName: t("V*launcher"),
            flex: 1,
            headerAlign: "center",
            justifyContent: "center",
            minWidth: 100,
            cellClassName: () => {
                return columnColor();
            },
        },
        {
            field: "gg",
            headerName: t("GG"),
            flex: 1,
            headerAlign: "center",
            justifyContent: "center",
            minWidth: 80,
            cellClassName: () => {
                return columnColor();
            },
        },
        {
            field: "aos",
            headerName: t("AOS"),
            flex: 1,
            headerAlign: "center",
            justifyContent: "center",
            minWidth: 80,
            cellClassName: () => {
                return columnColor();
            },
        },

        {
            field: "modemFW",
            headerName: t("ModemFW"),
            flex: 1,
            headerAlign: "center",
            justifyContent: "center",
            minWidth: 120,
            cellClassName: () => {
                return columnColor();
            },
        },
        {
            field: "microFW",
            headerName: t("MicroFW"),
            flex: 1,
            headerAlign: "center",
            justifyContent: "center",
            minWidth: 110,
            cellClassName: () => {
                return columnColor();
            },
        },
        {
            field: "dev",
            headerName: t("Dev"),
            flex: 1,
            headerAlign: "center",
            justifyContent: "center",
            minWidth: 80,
            cellClassName: () => {
                return columnColor();
            },
        },
        {
            field: "ctl",
            headerName: t("CTL"),
            flex: 1,
            headerAlign: "center",
            justifyContent: "center",
            minWidth: 80,
            cellClassName: () => {
                return columnColor();
            },
        },
        {
            field: "action",
            headerName: t("Action"),
            cellClassName: "chat-icon-wrapper",
            headerAlign: "center",
            justifyContent: "center",
            minWidth: 80,
            renderCell: (params) => {
                return (
                    <div className="chat-icon-wrapper" style={{ cursor: "pointer" }}>
                        <Tooltip title={t("Send_Message")}>
                            <button
                                disabled={
                                    isUserBasic(getUserRole && getUserRole?.Role) ||
                                    isUserReadOnly(getUserRole && getUserRole?.Role)
                                }
                                onClick={(e) => {
                                    e.stopPropagation();
                                    isLoading.get()
                                        ? isLoading.set(false)
                                        : isLoading.set(true);
                                    isLoading.get()
                                        ? setCarNumber.set(params?.row?.action?.Car.CarNumber)
                                        : setMsgToSingleCar.set(null);
                                    isLoading.get() ? (
                                        <>
                                            {carsForMessagesGetter.set([
                                                params?.row?.action?.Car.CarNumber,
                                            ])}
                                            {msgBtnState.set({
                                                state: true,
                                                activeNo: params?.row?.action?.Car.CarNumber,
                                                carGpsiCarId: params?.row?.action?.Car.GpsiCarId,
                                            })}
                                        </>
                                    ) : (
                                        carsForMessagesGetter.set(null)
                                    );
                                    isLoading.get()
                                        ? carsGpsSelectorData.set([
                                            params?.row?.action?.Car.GpsiCarId,
                                        ])
                                        : carsGpsSelectorData.set(null);
                                }}
                            >
                                <img src={ChatIcon} alt="send-msg" />
                            </button>
                        </Tooltip>

                        {updatesList(params?.row?.action) && (
                            <Tooltip title={updatesList(params?.row?.action)}>
                                <span>
                                    <SoftwareUpdateIcon />
                                </span>
                            </Tooltip>
                        )}
                    </div>
                );
            },
        },
        {
            field: "icons",
            headerName: "",
            cellClassName: "signal-icon-wrapper",
            headerAlign: "center",
            justifyContent: "center",
            minWidth: 200,
            sortable: false,
            flex: 1,
            renderCell: (params) => {
                let car = params?.row?.icons;
                return (
                    <div>
                        <div
                            style={{
                                gap: "10px",
                                width: "99px",
                                alignItems: "center",
                                display: "flex",
                            }}
                        >
                            <Tooltip
                                title={t(
                                    "This_car_has_a_critical_fault_or_in_alert_Action_Zone"
                                )}
                            >
                                <div>
                                    {(isActionZoneAlert(
                                        getCarPathActionZone,
                                        car?.Car?.ActionZoneId
                                    ) ||
                                        car?.Car?.MaxHolesExceeded ||
                                        car?.Car?.hasChargeAlert) && (
                                            <ExclamationMarkIconWithBorder />
                                        )}
                                </div>
                            </Tooltip>

                            <Tooltip title={toolTipIcon(car)}>
                                <span className="list-view-car-icon">
                                    {renderCarIcon(car)}
                                </span>
                            </Tooltip>
                            <Tooltip title={t("This_car_is_tagged")}>
                                <div style={{ alignItems: "center" }}>
                                    {taggedCarsSaverGlobalState
                                        .get()
                                        .find((item) => item === car?.Car.CarNumber) ||
                                        JSON.parse(
                                            localStorage.getItem("taggedCarsData")
                                        )?.tagCarsDataFilters.find(
                                            (item) => item === car?.Car.CarNumber
                                        ) ? (
                                        <TagCarGreenIcon />
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            </Tooltip>
                            {isWifi(car?.Car) ? (
                                <Tooltip title={t("This_car_is_connected_via_Wi-Fi")}>
                                    <div style={{ alignItems: "center" }}>
                                        <SignalIcon
                                            width="20px"
                                            height="18.5px"
                                            color="#5AADFF"
                                        />
                                    </div>
                                </Tooltip>
                            ) : (
                                <span style={{ width: "24px" }}></span>
                            )}
                            <Tooltip title={showTooltipTitle(car)}>
                                <div style={{ alignItems: "center" }}>
                                    {showDistanceUnits(car)}
                                </div>
                            </Tooltip>
                            <div style={{ width: "24px" }}>
                                {maxHolesDataDisplay(car?.Car?.MaxHolesAllowedCar)}
                            </div>

                            {renderLockMode(car?.Car)}

                            {isOutOfService(car) ? (
                                <>
                                    <Tooltip title="This car is marked out of service">
                                        {/* <div> */}
                                        <CarIconLegendIcon width={18} height={25} />
                                        {/* </div> */}
                                    </Tooltip>
                                </>
                            ) : (
                                <span style={{ width: "24px" }}></span>
                            )}
                        </div>
                        <div>
                            <ThreeDots />
                        </div>
                    </div>
                );
            },
        },
    ];

    const isAdminOrSupport = isUserAdmin(getUserRole?.Role) || isUserSupport(getUserRole?.Role);

    const appInfoFields = new Set([
        'pmid',
        'vapp',
        'vui',
        'vlauncher',
        'gg',
        'aos',
        'modemFW',
        'microFW',
        'dev',
        'ctl',
    ]);

    const simInfoFields = new Set([
        'simCard',
        'imei',
    ]);

    const restrictedNonAdminFields = new Set([
        'gpsiID',
        'lastRT',
        'lastWiFi',
        ...appInfoFields,
        ...simInfoFields,
    ]);

    const visibleColumns = columns.filter((col) => {
        const field = col.field;

        // Admin / Support logic
        if (isAdminOrSupport) {
            if (toggleAppInfo.get() && appInfoFields.has(field)) {
                return false;
            }

            if (toggleSimInfo.get() && simInfoFields.has(field)) {
                return false;
            }

            return true;
        }

        // Privilege-based overrides
        if (getUserRole?.privileges && getUserRole?.privileges.includes(userPrivileges.LastRTWiFI) && (field === 'lastRT' || field === 'lastWiFi')) {
            return true;
        }

        // Non-admin restrictions
        if (restrictedNonAdminFields.has(field)) {
            return false;
        }

        return true;
    });


    const useStyles = makeStyles({
        evenRow: {
            backgroundColor: 'rgb(244, 244, 212)', // Light gray for even rows
        },
        oddRow: {
            backgroundColor: '#ffffff', // White for odd rows
        },
    });

    const classes = useStyles();
    const getRowClassName = (params) => {
        return params.indexRelativeToCurrentPage % 2 === 0 ? classes.evenRow : classes.oddRow;
    };

    return (
        <>
            {/* ********************** List View****************************************************************************       */}

            {toggleFleetCarList.get() == fleetViewMode.SmallList ? (
                <CardWrapper className="list-view">
                    <CarSection
                        className="non-table"
                        style={backColor(car)}
                        onClick={() => {
                            handleCarClick(
                                car?.Car,
                                car?.Car?.CarNumber,
                                car?.Car?.GpsiCarId,
                                car?.Car?.MaxSpeed,
                                car?.Car?.DistanceUnits,
                                car?.Car?.MaxHolesAllowedCar,
                                car?.Car?.CarType,
                                car?.Car?.DistancesEnabledCar
                            );
                        }}
                    >
                        <img src={BigCarImage} alt="car" className="card-view" />
                        <h3>{car?.Car?.CarNumber}</h3>

                        <span className="card-view">{car?.Car?.GpsiCarId}</span>
                        {renderCarName()}
                    </CarSection>
                    <InfoSection
                        className="non-table"
                        onClick={() => showCarDetails(car)}
                    >
                        <div className="msg-section">
                            <div className="uper-section">
                                <div className="chat-download">
                                    <Tooltip title={toolTipIcon(car)}>
                                        <span
                                            style={{ display: "inline-flex" }}
                                            className="list-view-car-icon"
                                        >
                                            {renderCarIcon(car)}
                                        </span>
                                    </Tooltip>
                                    <button
                                        disabled={
                                            isUserBasic(getUserRole && getUserRole?.Role) ||
                                            isUserReadOnly(getUserRole && getUserRole?.Role)
                                        }
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            isLoading.get()
                                                ? isLoading.set(false)
                                                : isLoading.set(true);
                                            isLoading.get()
                                                ? setCarNumber.set(car.Car.CarNumber)
                                                : setMsgToSingleCar.set(null);
                                            isLoading.get() ? (
                                                <>
                                                    {carsForMessagesGetter.set([car.Car.CarNumber])}
                                                    {msgBtnState.set({
                                                        state: true,
                                                        activeNo: car.Car.CarNumber,
                                                        carGpsiCarId: car.Car.GpsiCarId,
                                                    })}
                                                </>
                                            ) : (
                                                carsForMessagesGetter.set(null)
                                            );
                                            isLoading.get()
                                                ? carsGpsSelectorData.set([car.Car.GpsiCarId])
                                                : carsGpsSelectorData.set(null);
                                        }}
                                    >
                                        <img
                                            title={t("Send_Message")}
                                            src={ChatIcon}
                                            alt="chat-icon"
                                        />
                                    </button>
                                    {updatesList(car) && (
                                        <Tooltip title={updatesList(car)}>
                                            <span>
                                                <SoftwareUpdateIcon />
                                            </span>
                                        </Tooltip>
                                    )}
                                </div>

                                <div className="signal-icon">
                                    <Tooltip title={renderHoleNumber1()}>
                                        <span>{renderHoleNumber(car)}</span>
                                    </Tooltip>
                                    {isWifi(car?.Car) && (
                                        <Tooltip title={t("This_car_is_connected_via_Wi-Fi")}>
                                            <div>
                                                <SignalIcon
                                                    width="20px"
                                                    height="18.5px"
                                                    color="#5AADFF"
                                                />
                                            </div>
                                        </Tooltip>
                                    )}
                                    {isStale(car?.Car) && (
                                        <Tooltip
                                            title={t("This_car_is_not_communicating_with_server")}
                                        >
                                            <div>
                                                <CarNotCommunicatingImage color="red" />
                                            </div>
                                        </Tooltip>
                                    )}

                                    {renderLockMode(car?.Car)}
                                </div>

                                <Tooltip title={showTooltipTitle(car)}>
                                    <div>{showDistanceUnits(car)}</div>
                                </Tooltip>

                                <div>{maxHolesDataDisplay(car?.Car?.MaxHolesAllowedCar)}</div>
                                <Tooltip
                                    title={t(
                                        "This_car_has_a_critical_fault_or_in_alert_Action_Zone"
                                    )}
                                >
                                    <div>
                                        {(isActionZoneAlert(
                                            getCarPathActionZone,
                                            car?.Car?.ActionZoneId
                                        ) ||
                                            car?.Car?.MaxHolesExceeded ||
                                            car?.Car?.hasChargeAlert) && (
                                                <ExclamationMarkIconWithBorder />
                                            )}
                                    </div>
                                </Tooltip>
                                <Tooltip title={paceString(car)}>
                                    <div className="flex">
                                        {paceWarning && (
                                            <div className="flex">
                                                <AccessTimeOutlinedIcon style={{ color: "orange" }} />
                                                <span
                                                    style={{
                                                        color: "orange",
                                                    }}
                                                >
                                                    {" "}
                                                    {Math.abs(car?.Car?.Pace)}
                                                </span>
                                            </div>
                                        )}
                                        {paceCritical && (
                                            <div className="flex">
                                                <AccessTimeOutlinedIcon style={{ color: "red" }} />
                                                <span
                                                    style={{
                                                        color: "red",
                                                    }}
                                                >
                                                    {Math.abs(car?.Car?.Pace)}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </Tooltip>
                                <Tooltip title={t("This_car_is_tagged")}>
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        {tagFind || tagFind2 ? <TagCarGreenIcon /> : <></>}
                                    </div>
                                </Tooltip>

                                <div className="top-icon">
                                    {isOutOfService(car) && (
                                        <>
                                            <Tooltip title="This car is marked out of service">
                                                {/* <div> */}
                                                <CarIconLegendIcon width={24} height={25} />
                                                {/* </div> */}
                                            </Tooltip>
                                        </>
                                    )}
                                    <>
                                        <RenderBatteryColumn
                                            car={car?.Car}
                                            canCommunicate={car?.CanCarCommunicate}
                                            userRole={getUserRole && getUserRole?.Role}
                                            getPrivilegeAction={getPrivilegeAction}
                                            privilege={privilege}
                                            getChargeHistoryAction={getChargeHistoryAction}
                                        />
                                        {carNotGuardianCapable(car) && <span title="This car is NOT Guardian capable" style={{ fontSize: '0.7em', textAlign: 'right', marginLeft: 4, color: '#cc0404' }}>
                                            <NotGuardianCapableIcon width={17} height={17} />
                                        </span>}
                                    </>
                                </div>
                            </div>
                        </div>

                        <div className="time-section card-view">
                            <p>
                                {t("Last_updated")} <span>{lastUpdate()}</span>
                            </p>
                            <p className="date-info">
                                <img src={TimeIcon} alt="time-icon" />
                                {checkLastDate()}
                            </p>
                        </div>
                    </InfoSection>
                </CardWrapper>
            ) : (
                <></>
            )}

            {/* ********************** Grid View****************************************************************************       */}

            {toggleFleetCarList.get() == fleetViewMode.GridList ? (
                <CardWrapper className="grid-view-card">
                    <CarSection
                        className="non-table"
                        style={backColor(car)}
                        onClick={() => {
                            handleCarClick(
                                car?.Car,
                                car?.Car?.CarNumber,
                                car?.Car?.GpsiCarId,
                                car?.Car?.MaxSpeed,
                                car?.Car?.DistanceUnits,
                                car?.Car?.MaxHolesAllowedCar,
                                car?.Car?.CarType
                            );
                        }}
                    >
                        <BigCar display="none" className="card-view" width={74} height={61} />
                        <h3>{car?.Car?.CarNumber}</h3>

                        <span className="card-view">{car?.Car?.GpsiCarId}</span>
                    </CarSection>
                    <InfoSection className="non-table grid-card" onClick={() => setOpenCarDetail(true)}>
                        <div className="msg-section">
                            <div className="uper-section">
                                <div className="chat-download">
                                    <button
                                        disabled={
                                            isUserBasic(getUserRole && getUserRole?.Role) ||
                                            isUserReadOnly(getUserRole && getUserRole?.Role)
                                        }
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            isLoading.get()
                                                ? isLoading.set(false)
                                                : isLoading.set(true);
                                            isLoading.get()
                                                ? setCarNumber.set(car.Car.CarNumber)
                                                : setMsgToSingleCar.set(null);
                                            isLoading.get() ? (
                                                <>
                                                    {carsForMessagesGetter.set([car.Car.CarNumber])}
                                                    {msgBtnState.set({
                                                        state: true,
                                                        activeNo: car.Car.CarNumber,
                                                        carGpsiCarId: car.Car.GpsiCarId,
                                                    })}
                                                </>
                                            ) : (
                                                carsForMessagesGetter.set(null)
                                            );
                                            isLoading.get()
                                                ? carsGpsSelectorData.set([car.Car.GpsiCarId])
                                                : carsGpsSelectorData.set(null);
                                        }}
                                    >
                                        <img src={ChatIcon} alt="chat-icon" />
                                        <span className="card-view">{t("Send_Message")}</span>
                                    </button>
                                    {updatesList(car) && (
                                        <Tooltip title={updatesList(car)}>
                                            <span>
                                                <SoftwareUpdateIcon />
                                            </span>
                                        </Tooltip>
                                    )}
                                </div>
                                <div className="top-icon">
                                    <Tooltip title={toolTipIcon(car)}>
                                        <span
                                            style={{ display: "inline-flex" }}
                                            className="list-view-car-icon"
                                        >
                                            {renderCarIcon(car)}
                                        </span>
                                    </Tooltip>
                                    <Tooltip
                                        title={t(
                                            "This_car_has_a_critical_fault_or_in_alert_Action_Zone"
                                        )}
                                    >
                                        <div>
                                            {(isActionZoneAlert(
                                                getCarPathActionZone,
                                                car?.Car?.ActionZoneId
                                            ) ||
                                                car?.Car?.MaxHolesExceeded ||
                                                car?.Car?.hasChargeAlert) && (
                                                    <ExclamationMarkIconWithBorder />
                                                )}
                                        </div>
                                    </Tooltip>
                                    <Tooltip title={paceString(car)}>
                                        <div className="flex">
                                            {paceWarning && (
                                                <span
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "3px",
                                                        fontSize: "16px",
                                                    }}
                                                >
                                                    <AccessTimeOutlinedIcon style={{ color: "orange" }} />{" "}
                                                    {Math.abs(car?.Car?.Pace)}
                                                </span>
                                            )}
                                            {paceCritical && (
                                                <span
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "3px",
                                                        fontSize: "16px",
                                                    }}
                                                >
                                                    <AccessTimeOutlinedIcon style={{ color: "red" }} />{" "}
                                                    {Math.abs(car?.Car?.Pace)}
                                                </span>
                                            )}
                                        </div>
                                    </Tooltip>
                                    <Tooltip title={renderHoleNumber1()}>
                                        <span>
                                            <div
                                                style={{ display: "inline-flex", alignItems: "center" }}
                                            >
                                                {renderHoleNumber(car)}
                                            </div>
                                        </span>
                                    </Tooltip>

                                    {isWifi(car?.Car) && (
                                        <Tooltip title={t("This_car_is_connected_via_Wi-Fi")}>
                                            <div>
                                                <SignalIcon
                                                    width="20px"
                                                    height="18.5px"
                                                    color="#5AADFF"
                                                />
                                            </div>
                                        </Tooltip>
                                    )}
                                    <Tooltip title={t("This_car_is_tagged")}>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            {tagFind || tagFind2 ? <TagCarGreenIcon /> : <></>}
                                        </div>
                                    </Tooltip>

                                    <Tooltip title={showTooltipTitle(car)}>
                                        <div>{showDistanceUnits(car)}</div>
                                    </Tooltip>
                                    <div>{maxHolesDataDisplay(car?.Car?.MaxHolesAllowedCar)}</div>

                                    {isStale(car?.Car) && (
                                        <Tooltip title="This car is not communicating with server">
                                            <div>
                                                <CarNotCommunicatingImage color="red" />
                                            </div>
                                        </Tooltip>
                                    )}
                                    {renderLockMode(car?.Car)}
                                    {isOutOfService() && (
                                        <>
                                            <Tooltip title="This car is marked out of service">
                                                {/* <div> */}
                                                <CarIconLegendIcon width={24} height={25} />
                                                {/* </div> */}
                                            </Tooltip>
                                        </>
                                    )}
                                    <>
                                        <RenderBatteryColumn
                                            car={car?.Car}
                                            canCommunicate={car?.CanCarCommunicate}
                                            userRole={getUserRole && getUserRole?.Role}
                                            getPrivilegeAction={getPrivilegeAction}
                                            privilege={privilege}
                                            getChargeHistoryAction={getChargeHistoryAction}
                                        />
                                        {carNotGuardianCapable(car) && <span title="This car is NOT Guardian capable" style={{ fontSize: '0.7em', textAlign: 'right', marginLeft: 4, color: '#cc0404' }}>
                                            <NotGuardianCapableIcon width={17} height={17} />
                                        </span>}
                                    </>
                                </div>
                            </div>
                            <div className="player-section">
                                <div className="player-name">
                                    {player1 && (
                                        <span>
                                            <UserIcon /> {player1}
                                        </span>
                                    )}
                                    {player2 && (
                                        <span>
                                            <UserIcon /> {player2}
                                        </span>
                                    )}
                                </div>
                                <div className="pace-section">
                                    {paceWarning && (
                                        <span className="pace" style={{ color: "orange" }}>
                                            {paceString(car)}
                                        </span>
                                    )}

                                    {paceCritical && (
                                        <span className="pace" style={{ color: "red" }}>
                                            {paceString(car)}
                                        </span>
                                    )}

                                    {!isStale(car?.Car) &&
                                        isCarInUse(car?.Car) &&
                                        renderLocationString()}
                                </div>
                            </div>
                        </div>
                        <div className="time-section card-view">
                            <p>
                                {t("Last_updated")} <span>{lastUpdate()}</span>
                            </p>
                            <p className="date-info">
                                <img src={TimeIcon} alt="time-icon" />
                                {checkLastDate()}
                            </p>
                        </div>
                    </InfoSection>
                </CardWrapper>
            ) : (
                <></>
            )}

            {/* ********************** Table View****************************************************************************       */}

            <Modal
                open={openCarDetail}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <CarDetailsModalWrapper>
                    <CarDetails
                        carInformation={car}
                        handleClick={handleClose}
                        PaceString={paceString}
                    />
                </CarDetailsModalWrapper>
            </Modal>

            {toggleFleetCarList.get() === fleetViewMode.TableList ? (
                <Box
                    sx={{
                        height: {
                            xs: "calc(100vh - 275px)", // mobile
                            sm: "calc(100vh - 215px)", // desktop
                        },
                        width: "100%",
                    }}
                >
                    <DataGridPro
                        rows={rows}
                        columns={visibleColumns}
                        rowHeight={35}             // height of each row
                        headerHeight={35}
                        getRowId={(row) => row.id || row.index}
                        sortModel={sortModel}
                        onSortModelChange={(newSortModel) => {
                            setSortModel(newSortModel);
                            // Update global sort state to sync with dropdown
                            if (newSortModel.length > 0) {
                                const { field, sort } = newSortModel[0];
                                sortBy.set(field);
                                sortButton.set(sort === 'desc');
                            }
                        }}
                        sortingOrder={['asc', 'desc']}
                        disableSelectionOnClick
                        disableColumnMenu
                        hideFooter
                        disableVirtualization={false} // keep virtualization
                        onCellClick={handleCellClick}
                        getRowClassName={getRowClassName}
                        getRowSpacing={(params) => ({
                            top: 2.5,
                            bottom: 2.5,
                        })} // proper spacing without breaking virtualization
                        sx={{
                            '& .MuiDataGrid-row': {
                                minHeight: 35,   // must match rowHeight
                                boxShadow: "0px 4px 15px rgba(0,0,0,0.1)",
                                '&:hover': {
                                    backgroundColor: '#f1f1f1',
                                },
                            },
                            '& .MuiDataGrid-cell': {
                                fontSize: "12px",
                                color: "var(--text-primary)",
                                padding: "2px 8px",
                                textAlign: "center",
                                outline: 'none',
                                '&:focus': {
                                    outline: 'none',
                                },
                            },
                            '& .MuiDataGrid-filler--pinnedLeft': {
                                width: '0 !important',
                            },
                        }}
                        components={{
                            NoRowsOverlay: () => (
                                <Stack
                                    height="100%"
                                    alignItems="center"
                                    justifyContent="center"
                                >
                                    {t("No_data")}
                                </Stack>
                            ),
                        }}
                    />
                </Box>
            ) : (
                <></>
            )}
        </>
    );
});

export default CarInfoCard;
